import { Typography } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  lineHeight: theme.typography.subtitle2.lineHeight,
  letterSpacing: theme.typography.subtitle2.letterSpacing,
  color: theme.palette.text.primary,

  '& strong': {
    fontWeight: theme.typography.fontWeightMedium,
  },

  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.body1.fontSize,
  },
}));
